var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReceipt = function SvgReceipt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    "data-name": "Layer 4",
    viewBox: "0 0 24 24",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Bill, Receipt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,22a1,1,0,0,1-.707-.293L12,20.414l-1.293,1.293a1,1,0,0,1-1.414,0l-1.42-1.42L5.555,21.832A1,1,0,0,1,4,21V5A3,3,0,0,1,7,2H17a3,3,0,0,1,3,3V21a1,1,0,0,1-1.555.832l-2.318-1.545-1.42,1.42A1,1,0,0,1,14,22Zm-2-4a1,1,0,0,1,.707.293L14,19.586l1.293-1.293a1,1,0,0,1,1.262-.125L18,19.131V5a1,1,0,0,0-1-1H7A1,1,0,0,0,6,5V19.131l1.445-.963a1,1,0,0,1,1.262.125L10,19.586l1.293-1.293A1,1,0,0,1,12,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,8H9A1,1,0,0,1,9,6h6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12H9a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,16H9a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReceipt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/receipt.0fc2860d.svg";
export { ForwardRef as ReactComponent };